module.exports = __webpack_public_path__ + "img/pipe.8cf9562b.png";